import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { makeIsLoggedUserOwnerSelector } from "~/store/selectors/selector.users";

export const RequireCanAccessAppsAndIntegrations = ({ children, redirectTo }) => {
  const getIsOwner = useMemo(makeIsLoggedUserOwnerSelector, []);
  const isOwner = useSelector((state) => getIsOwner(state));

  return isOwner ? children : <Navigate to={redirectTo} />;
};

RequireCanAccessAppsAndIntegrations.propTypes = {
  redirectTo: PropTypes.string,
  children: PropTypes.any,
};

RequireCanAccessAppsAndIntegrations.defaultProps = {
  redirectTo: "/not-found",
};
